async function add_item(variantId, quantity, properties = {}) {
    const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            properties: properties
        })
    });
}

function financial(x) {
    return parseFloat(x) / 100;
}

function boolean(x) {
    return x === 'true';
}


function paperTypeAbTest() {
    const v2Block = document.querySelector('.paper-type-selector-v2-block');
    if (v2Block) {
        const computedStyle = window.getComputedStyle(v2Block);
        if (computedStyle.display !== 'none') {
            return document.getElementById('sticky-paper-v2').checked;
        }
    }
    return document.getElementById('sticky-paper').checked;
}


const widthInput = document.getElementById('customWidth');
const heightInput = document.getElementById('customHeight');
const configuratorBlock = document.querySelector('.configurator-block');
const basePrice = financial(configuratorBlock.dataset.basePrice);
const compareAtPrice = financial(configuratorBlock.dataset.compareAtPrice);
const hasDiscount = boolean(configuratorBlock.dataset.hasDiscount);
const productTitle = configuratorBlock.dataset.productTitle;


const priceDisplay = document.querySelectorAll('.calculatedPrice');

var cropper = null;

function updatePrice() {
    const baseWidth = parseFloat(widthInput.value);
    const baseHeight = parseFloat(heightInput.value);
    const width = baseWidth;
    const height = baseHeight;

    var currentBasePrice = basePrice;
    if (paperTypeAbTest()) {
        currentBasePrice += 10;
    }

    if (!isNaN(width) && !isNaN(height)) {
        cropper.setAspectRatio(width / height);

        if (width > height) {
            var new_height = cropper.getContainerData().width * (height / width);
            cropper.setCropBoxData({
                left: 0,
                top: (cropper.getContainerData().height / 2) - (new_height / 2),
                width: cropper.getContainerData().width,
                height: new_height
            });
        } else {
            var new_width = cropper.getContainerData().height * (width / height);
            cropper.setCropBoxData({
                left: (cropper.getContainerData().width / 2) - (new_width / 2),
                top: 0,
                width: new_width,
                height: cropper.getContainerData().height
            });
        }

        const totalArea = (baseWidth / 100) * (baseHeight / 100);
        const totalPrice = currentBasePrice * totalArea;

        var originalPrice = totalPrice;
        if (hasDiscount) {
            var originalPrice = compareAtPrice;
            if (paperTypeAbTest()) {
                originalPrice += 10;
            }
            originalPrice *= totalArea;
        }

        priceDisplay.forEach(function (element) {
            if (hasDiscount) {
                element.innerHTML = '<span style="text-decoration: line-through;font-weight:normal;">' + originalPrice.toFixed(2) + '€</span> <span>' + totalPrice.toFixed(2) + '€';
            } else {
                element.textContent = totalPrice.toFixed(2) + '€';
            }
        });

        const scalapay_text_amount = document.getElementById('scalapay_text_amount');

        if (hasDiscount) {
            var difference = originalPrice.toFixed(2) - totalPrice.toFixed(2);
            scalapay_text_amount.innerHTML = '<b>DERNIÈRE CHANCE : Économisez ' + difference.toFixed(2) + '€ en passant commande aujourd\'hui !</b>';
        } else {
            scalapay_text_amount.innerHTML = 'ou 3 fois <b>' + (totalPrice / 3).toFixed(2) + '€</b> sans frais avec ';
        }


        var top_width_bar = document.getElementById('top_width_bar');
        var top_height_bar = document.getElementById('right_height_bar');

        top_width_bar.innerHTML = width + 'cm';
        top_height_bar.innerHTML = `<div id="returned_height_bar_number">${height}cm</div>`;
        top_width_bar.style.width = cropper.getCropBoxData().width + 'px';
        top_height_bar.style.height = cropper.getCropBoxData().height + 'px';

        top_width_bar.style.marginLeft = cropper.getCropBoxData().left + 'px';
        top_height_bar.style.marginTop = cropper.getCropBoxData().top + 'px';

        var returned_height_bar_number = document.getElementById('returned_height_bar_number');
        //margin top 
        returned_height_bar_number.style.marginTop = (cropper.getCropBoxData().height / 2) - (returned_height_bar_number.offsetHeight / 2) + 'px';

        // Calculate number of rolls and price per roll
        const rollWidthCm = 50; // Standard roll width of 50 cm
        const numberOfRolls = Math.ceil(baseWidth / rollWidthCm); // Round up to ensure enough rolls
        const pricePerRoll = totalPrice / numberOfRolls;

        // Update the roll delivery info
        document.getElementById('numberOfRolls').textContent = numberOfRolls;
        document.getElementById('pricePerRoll').textContent = pricePerRoll.toFixed(2);
    }
}

// Nouvelle fonction pour mettre à jour seulement le prix (sans repositionner le crop)
function updatePriceOnly() {
    const baseWidth = parseFloat(widthInput.value);
    const baseHeight = parseFloat(heightInput.value);

    var currentBasePrice = basePrice;
    if (paperTypeAbTest()) {
        currentBasePrice += 10;
    }

    if (!isNaN(baseWidth) && !isNaN(baseHeight)) {
        const totalArea = (baseWidth / 100) * (baseHeight / 100);
        const totalPrice = currentBasePrice * totalArea;

        var originalPrice = totalPrice;
        if (hasDiscount) {
            var originalPrice = compareAtPrice;
            if (paperTypeAbTest()) {
                originalPrice += 10;
            }
            originalPrice *= totalArea;
        }

        priceDisplay.forEach(function (element) {
            if (hasDiscount) {
                element.innerHTML = '<span style="text-decoration: line-through;font-weight:normal;">' + originalPrice.toFixed(2) + '€</span> <span>' + totalPrice.toFixed(2) + '€';
            } else {
                element.textContent = totalPrice.toFixed(2) + '€';
            }
        });

        const scalapay_text_amount = document.getElementById('scalapay_text_amount');

        if (hasDiscount) {
            var difference = originalPrice.toFixed(2) - totalPrice.toFixed(2);
            scalapay_text_amount.innerHTML = '<b>DERNIÈRE CHANCE : Économisez ' + difference.toFixed(2) + '€ en passant commande aujourd\'hui !</b>';
        } else {
            scalapay_text_amount.innerHTML = 'ou 3 fois <b>' + (totalPrice / 3).toFixed(2) + '€</b> sans frais avec ';
        }

        // Calculate number of rolls and price per roll
        const rollWidthCm = 50; // Standard roll width of 50 cm
        const numberOfRolls = Math.ceil(baseWidth / rollWidthCm); // Round up to ensure enough rolls
        const pricePerRoll = totalPrice / numberOfRolls;

        // Update the roll delivery info
        document.getElementById('numberOfRolls').textContent = numberOfRolls;
        document.getElementById('pricePerRoll').textContent = pricePerRoll.toFixed(2);
    }
}

var image = document.querySelector('#cropperImage');

function load_cropper() {
    cropper = new Cropper(image, {
        autoCropArea: 1,
        viewMode: 1,
        movable: false,
        zoomable: false,
        zoomOnTouch: false,
        zoomOnWheel: false,
        restore: false,
        wheelZoomRatio: 0,
        rotatable: false,
        scalable: true,
        dragMode: 'move',
        modal: true,
        cropBoxResizable: false,
        cropBoxMovable: true,
        cropmove: function (event) {
            document.querySelector('.cropper-canvas').classList.add('copper-canvas-moving');
            // move bars
            var top_width_bar = document.getElementById('top_width_bar');
            var top_height_bar = document.getElementById('right_height_bar');

            top_height_bar.style.height = cropper.getCropBoxData().height + 'px';

            top_width_bar.style.marginLeft = cropper.getCropBoxData().left + 'px';
            top_height_bar.style.marginTop = cropper.getCropBoxData().top + 'px';
        },
        cropend: function (event) {
            document.querySelector('.cropper-canvas').classList.remove('copper-canvas-moving');
        },
        ready: function () {
            updatePrice();
            document.getElementById('cropperButton').disabled = false;
        }
    });
}

var show_resize_warning = () => {
    var cropping_table_resize_warning_box = document.querySelector('.cropping_table_resize_warning_box');

    cropping_table_resize_warning_box.classList.add('show');

    setTimeout(function () {
        cropping_table_resize_warning_box.classList.add('show-bump');
    }, 500);

    setTimeout(function () {
        cropping_table_resize_warning_box.classList.remove('show', 'show-bump');
    }, 5000);
};

widthInput.addEventListener('input', () => {
    updatePrice();
    show_resize_warning();
});
heightInput.addEventListener('input', () => {
    updatePrice();
    show_resize_warning();
});

document.querySelectorAll('.paper-type').forEach(function (element) {
    element.addEventListener('change', updatePriceOnly);
});

window.addEventListener('DOMContentLoaded', function () {
    let date = new Date();
    date.setDate(date.getDate() + 2); // Ajoute 2 jours à la date actuelle

    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);

    document.querySelectorAll(".new_day").forEach(function (element) {
        element.textContent = day;
    });
    document.querySelectorAll(".new_month").forEach(function (element) {
        element.textContent = getMonthName(month);
    });

    document.getElementById('reverseMode').addEventListener('change', function () {
        if (this.checked) {
            cropper.scaleX(-1);
        } else {
            cropper.scaleX(1);
        }
    });

    function getMonthName(monthNumber) {
        const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
        return months[parseInt(monthNumber) - 1];
    }

    function initInfoPopup(iconId, popupId) {
        const icon = document.getElementById(iconId);
        const popup = document.getElementById(popupId);
        const closeBtn = popup.querySelector('.info-popup-close');

        // Detect whether user is on a smaller screen (mobile/tablet)
        let isMobile = window.matchMedia("(max-width: 768px)").matches;

        if (!isMobile) {
            // On larger screens: show the popup on hover, hide it on mouseout.
            icon.addEventListener('mouseenter', () => {
                popup.style.display = 'block';
            });
            icon.addEventListener('mouseleave', () => {
                popup.style.display = 'none';
            });
            popup.addEventListener('mouseenter', () => {
                popup.style.display = 'block';
            });
            popup.addEventListener('mouseleave', () => {
                popup.style.display = 'none';
            });
        }

        // On mobile (or fallback), use click to toggle show/hide
        icon.addEventListener('click', (e) => {
            // Prevent immediate "mouseleave" from closing it
            e.stopPropagation();
            if (popup.style.display === 'block') {
                popup.style.display = 'none';
            } else {
                popup.style.display = 'block';
            }
        });

        // Close button for mobile
        closeBtn.addEventListener('click', () => {
            popup.style.display = 'none';
        });

        // (Optional) if you want to close when clicking anywhere else on mobile:
        document.body.addEventListener('click', (ev) => {
            if (isMobile && popup.style.display === 'block') {
                // If user clicked outside the popup & icon
                if (!popup.contains(ev.target) && ev.target !== icon) {
                    popup.style.display = 'none';
                }
            }
        }, true);
    }

    initInfoPopup('infoIcon1', 'infoPopup1');
    initInfoPopup('infoIcon2', 'infoPopup2');

    load_cropper();
});

let lastWidth = window.innerWidth;
window.addEventListener('resize', function () {
    let newWidth = window.innerWidth;

    if (lastWidth !== newWidth) {
        updatePrice();
    }
});

var _learnq = _learnq || [];

document.getElementById('cropperButton').addEventListener('click', function () {

    var error_box = document.getElementById('add_to_cart_error_box');

    error_box.innerHTML = '';
    if (widthInput.value == '' || heightInput.value == '') {
        error_box.style.display = 'block';
        error_box.innerHTML = 'Veuillez d\'abord renseigner les dimensions de votre papier peint.';
        return;
    }

    if (widthInput.value < 100 || widthInput.value > 6000) {
        error_box.style.display = 'block';
        error_box.innerHTML = 'La largeur de votre papier peint doit être comprise entre 100cm et 6 mètres.<br/>Si vous souhaitez un plus grand format veuillez nous contacter à <a href="mailto:info@lepapierpeint.fr" style="color:#2e2e2e;">info@lepapierpeint.fr</a>';
        return;
    }

    if (heightInput.value < 100 || heightInput.value > 4000) {
        error_box.style.display = 'block';
        error_box.innerHTML = 'La hauteur de votre papier peint doit être comprise entre 100cm et 4 mètres.<br/>Si vous souhaitez un plus grand format veuillez nous contacter à <a href="mailto:info@lepapierpeint.fr" style="color:#2e2e2e;">info@lepapierpeint.fr</a>';
        return;
    }

    _learnq.push(['track', 'Added to Cart', item]);

    // Get crop coordinates and prepare parameters for localStorage
    const crop_box = cropper.getData();

    const product_id = document.querySelector('.configurator-block').dataset.productId;

    // Prepare all parameters for localStorage (without large image data)
    const orderData = {
        origin_url: cropperImage.src,
        product_id: product_id,
        width: widthInput.value,
        height: heightInput.value,
        sticky_paper: paperTypeAbTest(),
        reverse_mode: document.getElementById('reverseMode').checked,
        crop_box: {
            x: crop_box.x,
            y: crop_box.y,
            width: crop_box.width,
            height: crop_box.height
        },
        custom_metafields: {
            'Dimensions': heightInput.value + ' x ' + widthInput.value + ' cm' + (document.getElementById('reverseMode').checked ? ' (miroir)' : ''),
            'Type de papier': paperTypeAbTest() ? 'Autocollant' : 'Premium',
            '_product_title': productTitle
        }
    };

    // Store in localStorage
    localStorage.setItem('lepapierpeint_order_data', JSON.stringify(orderData));

    // Redirect immediately to loading page
    window.location.href = '/pages/chargement-de-votre-papier-peint';
});